const swiperCol3 = new Swiper(".look-book-full", {
  speed: 700,
  slidesPerView: 4,
  spaceBetween: 20,
  grabCursor: true,
  freeMode: true,
    mousewheel: { forceToAxis: true, invert: true },
  loop: false,
  keyboard: {
    enabled: true
  },
  scrollbar: {
    el: '.movement-scrollbar',
    draggable: true,
  },
   navigation: {
    nextEl: ".next-mov-1",
    prevEl: ".prev-mov-1"
  },
  breakpoints: {
    768: {
      slidesPerView: 1.3,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    }
  }
});




  
